import { bigNumberToReadable } from '@utils/big-number-to-readable';
import { type FC, memo } from 'react';
import styles from './exchange-rate.module.scss';
import { Decimal } from 'parrot-sui-sdk';
import type { BestSwapResult, ParrotCoinStruct } from 'src/types';
import { scaleDown } from '@utils/math';
import toastLoadingIcon from '@assets/images/parrot/toast-loading.svg';
import Block from '@components/block';

interface OwnProps {
  bestRoute: BestSwapResult;
  coinA: ParrotCoinStruct;
  coinB: ParrotCoinStruct;
  loading: boolean;
}

const ExchangeRate: FC<OwnProps> = ({ bestRoute, coinA, coinB, loading }) => {
  const price = new Decimal(1)
    .div(scaleDown(bestRoute.amount_in, coinA.decimals))
    .mul(scaleDown(bestRoute.amount_out, coinB.decimals))
    .toString();

  return (
    <div className={styles.best_route}>
      <img src={toastLoadingIcon} data-icon />
      {loading ? (
        <Block />
      ) : (
        <span>
          1&nbsp;{coinA.symbol}&nbsp;≈&nbsp;{bigNumberToReadable(price, 0)}
          &nbsp;{coinB.symbol}
        </span>
      )}
    </div>
  );
};

export default memo(ExchangeRate);
